import { defineStore, IStoreState } from "@/utils/store"

const login = defineStore({
  state: {
    isLoading: false,
    isChecked: false, // 协议同意
    showTooltip: false, // 提示气泡展示
  },
  mutations: {
    update(state, data) {
      data && Object.assign(state, data)
    },
  },
})

export default login
export type ILoginStoreState = IStoreState<typeof login.state>